export const initialCameraPosition: [number, number, number] = [0, 15, 0];

export const cameraDistance = 10;

export const markerWidth = 0.35;
export const markerHeight = markerWidth * 1.15; // aspect ratio of our marker
